import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../console/store/useAuthStore";
import { enum_api_uri } from "../utils/enum";

export interface CustomerData {
    customer_idx: number;
    customer_name: string;
    customer_category: number;
}

interface GetCustomerResponse {
    data: CustomerData[];
}

export const useGetCommonCustomer = (customer_category?: number, searchtxt?: string): UseQueryResult<GetCustomerResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetCustomerResponse, Error>({
        queryKey: ["getCommonCustomer", customer_category, searchtxt],
        queryFn: async () => {
            let url = enum_api_uri.common_get_customer;
            const params: string[] = [];
            if (customer_category !== undefined) params.push(`customer_category=${customer_category}`);
            if (searchtxt) params.push(`search=customer_name&searchtxt=${searchtxt}`);
            if (params.length) url += `?${params.join('&')}`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data;
        },
        enabled: customer_category === 1 ? !!searchtxt : true,
    });
};
